// extracted by mini-css-extract-plugin
export default {"container":"Shops_container__CCtah"};